/** Breadcrumb factories whose label depends on the provider (e.g. "Clusters" for Kubernetes). */

import { getAccountNoun, type CloudProvider } from "@stacklet/ui";

import { paths } from "app/constants/paths";

import type { BreadcrumbLink } from "app/constants/breadcrumbs";

export function getAccountsBreadcrumb(provider: CloudProvider): BreadcrumbLink {
  return {
    label: getAccountNoun(provider).pluralTitle,
    target: paths.adminAccounts,
  };
}

export function getAccountGroupsLabel(provider: CloudProvider): string {
  return `${getAccountNoun(provider).singularTitle} Groups`;
}

export function getAccountGroupsBreadcrumb(
  provider: CloudProvider,
): BreadcrumbLink {
  return {
    label: getAccountGroupsLabel(provider),
    target: `${paths.adminAccounts}?tab=account-groups`,
  };
}
